export default "__VITE_ASSET__CkqZr$w6__"